import {AccessTimeOutlined, AddCircle} from '@mui/icons-material';
import {useCan} from 'src/permissions/hooks';
import {Box, Button, Typography} from '@mui/material';
import {FC, useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {chargersApi} from 'src/api';
import AMPModal from 'src/components/common/AMPModal';
import {TimeIcon} from 'src/components/icons/TimeIcon';
import {ChargerScheduleCreateWrapper} from '../ChargerScheduleCreateWrapper';
import {ScheduleList} from '../ScheduleList';
import {
    actionButtonWrapperSx,
    emptyTitleWrapperSx,
    emptyWrapperSx,
    scheduleBadgeSx,
    scheduleTitleTextSx,
    titleSx,
    wrapperSx,
} from './ChargerSchedule.sx';
import {ChargerScheduleType} from './ChargerSchedule.types';
import {useAppSelector} from 'src/app/hooks';
import {GetScheduleRequest} from 'src/types';

export const ChargerSchedule: FC<ChargerScheduleType> = ({data}) => {
    const {authInfo} = useAppSelector((state) => state.common);
    const companyId = authInfo?.company?.id || authInfo?.employee?.company?.id;

    const [getSchedule, schedule] = chargersApi.useLazyGetScheduleQuery();
    const intl = useIntl();
    const canCreateSchedule = useCan('scheduleCharging.create');

    const [open, setOpen] = useState<boolean>(false);
    const dialogTitle = intl.formatMessage({id: 'addSchedule'});

    const handleGetSchedule = async () => {
        const input: GetScheduleRequest = {businessId: data.business.id, chargerId: data.id};

        if (companyId) {
            input.companyId = companyId;
        }
        await getSchedule(input);
    };

    const handleOpenModal = () => {
        setOpen(true);
    };

    const handleCloseModal = () => {
        setOpen(false);
    };

    useEffect(() => {
        void handleGetSchedule();
    }, []);
    return (
        <Box sx={wrapperSx}>
            <Box sx={titleSx}>
                <Box sx={scheduleBadgeSx}>
                    <AccessTimeOutlined/>
                </Box>
                <Typography sx={scheduleTitleTextSx}>
                    <FormattedMessage id="chargingSchedule"/>
                </Typography>
            </Box>
            {schedule.data?.length ? (
                <ScheduleList
                    data={schedule.data}
                    businessId={data.business.id}
                    chargerId={data.id}
                    chargerData={data}
                />
            ) : (
                <Box sx={emptyWrapperSx}>
                    <Box sx={emptyTitleWrapperSx}>
                        <Typography variant="h5">
                            <FormattedMessage id="noScheduleYet"/>
                        </Typography>
                        <TimeIcon/>
                    </Box>
                </Box>
            )}
            {canCreateSchedule && (
                <Box sx={actionButtonWrapperSx}>
                    <Button onClick={handleOpenModal}>
                        <AddCircle/>
                        <FormattedMessage id="addSchedule"/>
                    </Button>
                </Box>
                        )}
            <AMPModal
                handleClose={handleCloseModal}
                open={open}
                title={dialogTitle}
                type="md"
                fullWidth
                withoutPaddings
            >
                <ChargerScheduleCreateWrapper
                    handleClose={handleCloseModal}
                    businessId={data.business.id}
                    chargerId={data.id}
                    chargerData={data}
                />
            </AMPModal>
        </Box>
    );
};
